import React from 'react';
import AppContext from './AppContext';
import useBroadcastChannel from '../Helpers/useBroadcastChannel';

interface AppProviderProps {
  images: { [key: string]: string };
  svgInline: { [key: string]: React.FC };
  lotties: { [key: string]: any };
  navigation: { [key: string]: { path?: string; translationKey: string; externalPath?: any }[] };
  consts: {
    [key: string]:
      | string
      | number
      | boolean
      | string[]
      | number[]
      | { [key: string]: string | string[] | number[] | React.FC };
  };
  functions: { [key: string]: (...args: any) => any };
  children: React.ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({
  images,
  svgInline,
  lotties,
  navigation,
  consts,
  functions,
  children,
}) => {
  const { post } = useBroadcastChannel({
    name: 'my-app-channel',
    onMessage: (event: any) => {
      if (event.data === 'reload') {
        window.location.reload();
      }
    },
  });

  return (
    <AppContext.Provider
      value={{ images, svgInline, lotties, consts, navigation, functions, post }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
